import { Paper } from '@mui/material';
import TeamTable from 'components/SS/teamTable';

const MyTeam = () => {
  return (
    <Paper sx={{ flex: 1, p: { xs: 3, md: 5 } }}>
      <TeamTable />
    </Paper>
  );
};

export default MyTeam;
